import React from 'react';
import moment from "moment";


const ItemAddToCartWithoutCalendar = ({itemId, priceFormatted, unit}) => {
    const baseLink = window.links.reservation.new;

    let url = new URL(baseLink);
    url.searchParams.append('date', moment().format('YYYY-MM-DD'));
    url.searchParams.append('length', 1);
    url.searchParams.append('productId', itemId);
    url.searchParams.append('officeId', 1);
    const urlHref = url.toString();
    let aProps = {
        href: urlHref,
    };


    return <>
        <div className={'mb-4 fs-5'}>
            {priceFormatted} / {unit}
        </div>
        <a {...aProps} type="button" className="btn btn-primary">Přidat do poptávky &nbsp;&nbsp;&nbsp;<i
            className="fas fa-chevron-right"></i></a>
    </>
}

export default ItemAddToCartWithoutCalendar;